
import { useFlotasStore } from "@/store/erp";
import { useBodegaStore } from "@/store/erp/shared/bodega.store";
import { useCatalogoPlanCuentaStore } from "@/store/erp/shared/catalogo-plan-cuenta.store";
import { useCategoriaProductoStore } from "@/store/erp/shared/categoria-producto.store";
import { useIvaStore } from "@/store/erp/shared/iva.store";
import { usePlanStore } from "@/store/erp/system-settings/plan.store";
import { useEffect } from "react";
import { Outlet } from "react-router-dom";


const InventarioModule = () => {
  //STORE
  const getCategoriaProducto = useCategoriaProductoStore(
    (s) => s.getCategoriaProducto
  );
  const getBodega = useBodegaStore((s) => s.getBodega);
  const getIva = useIvaStore((s) => s.getIva);

  const getFlotas = useFlotasStore((s) => s.getFlotas);
  const getCatalogoPlanCuenta = useCatalogoPlanCuentaStore((s) => s.getCatalogoPlanCuenta);

  // ===========================================================================
  // para corporativos
  // ===========================================================================
  const getPlansCorporativos = usePlanStore(s => s.getPlansCorporativos);

  useEffect(() => {
    (async () => {
      const results = await Promise.allSettled([
        getCategoriaProducto({ page_size: 600, estado: true }),
        getBodega({ page_size: 600, estado: true }),
        getIva({ page_size: 600, estado: true }),
        getFlotas({ page_size: 600, estado: true }),
        getPlansCorporativos({ page_size: 600, estado: true }),
        getCatalogoPlanCuenta('FIBRAMAX')
      ]);
      
      results.forEach((result, index) => {
        if (result.status === 'rejected') {
          console.error(`Inventario data load failed at position ${index}:`, result.reason);
        }
      });
    })();
  }, []);

  return <Outlet />;
};

export default InventarioModule;
